<template>
  <div class="ts-h-screen ts-w-screen ts-flex ts-flex-col login-page">
    <div class="ts-flex ts-items-center ts-py-5 ts-bg-blue-500 ts-shadow-md">
      <h2 class="ts-my-0 ts-ml-4 ts-text-4xl ts-text-white ts-font-teko">
        SCHOOL ERP SYSTEM
      </h2>
      <span class="ts-flex-grow"></span>
      <span class="ts-mr-4 ts-text-white ts-text-xl ts-font-teko"
        >Version 2</span
      >
    </div>
    <div class="ts-flex-grow">
      <div
        class="ts-h-full ts-w-full ts-flex ts-items-center ts-justify-center"
      >
        <div class="promotional-box ts-mr-4">
          <vue-flux
            :options="vfOptions"
            :images="vfImages"
            :transitions="vfTransitions"
            ref="slider"
          >
            <!-- :captions="vfCaptions" -->
            <template v-slot:preloader>
              <flux-preloader />
            </template>

            <template v-slot:caption>
              <flux-caption />
            </template>

            <template v-slot:controls>
              <flux-controls />
            </template>

            <!-- <template v-slot:pagination>
              <flux-pagination />
            </template> -->

            <template v-slot:index>
              <flux-index />
            </template>
          </vue-flux>
        </div>
        <div class="ts-shadow ts-p-4 ts-bg-white ts-w-64 ts-rounded login-box">
          <div class="ts-w-full ts-flex ts-justify-center">
            <img :src="company_logo" alt="" width="150" />
          </div>
          <form @submit.prevent="login" class="margin-bottom-0">
            <div class="ts-mt-10">
              <div
                class="alert alert-danger fade show ts-mb-4"
                v-show="errorMessage != ''"
                v-html="errorMessage"
              ></div>
              <div class="form-group ts-mb-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text ts-inline-flex ts-w-10 ts-justify-center ts-items-center"
                      ><i class="fas fa-user"></i
                    ></span>
                  </div>
                  <input
                    type="text"
                    placeholder="Username"
                    class="form-control form-control-md input-login"
                    :class="{ 'is-invalid': errors.has('loginname') }"
                    v-model="loginname"
                  />
                  <div class="invalid-feedback" v-if="errors.has('loginname')">
                    {{ errors.first('loginname') }}
                  </div>
                </div>
              </div>
              <div class="form-group ts-mb-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text ts-inline-flex ts-w-10 ts-justify-center ts-items-center"
                      ><i class="fas fa-key"></i
                    ></span>
                  </div>
                  <div class="position-relative">
                    <input 
                      :type="showPassword ? 'text' : 'password'"
                      class="form-control form-control-md input-login pr-5 ts-rounded-bl-none ts-rounded-tl-none" style="width: 257px;"
                      placeholder="Password"
                      :class="{ 'is-invalid': errors.has('password') }"
                      v-model="password"
                    />
                    <span 
                      class="password-toggle"
                      @click="togglePassword"
                    >
                      <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                    </span>
                  </div>
                  <div class="invalid-feedback" v-if="errors.has('password')">
                    {{ errors.first('password') }}
                  </div>
                </div>
              </div>
              <div class="form-group ts-mb-4">
                <select
                  v-model="guard"
                  class="form-control form-control-md input-login"
                  :class="{ 'is-invalid': errors.has('guard') }"
                >
                  <option value="STAFF_GUARD_SECRET">Office Staff</option>
                  <option value="TEACHER_GUARD_SECRET">Teacher</option>
                  <option value="PARENTS_GUARD_SECRET">Parents</option>
                  <option value="STUDENT_GUARD_SECRET">Student</option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('guard')">
                  {{ errors.first('guard') }}
                </div>
              </div>
              <div class="ts-mt-5">
                <ts-button
                  type="submit"
                  class="btn btn-primary btn-block btn-md"
                  :waiting="loggingIn"
                >
                  Sign me in
                </ts-button>
              </div>
            </div>
          </form>
          <div class="ts-mt-16 ts-text-center ts-text-blue-500">
            <span>POWERED BY: TECHSTORE CREATIVE SOLUTIONS</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="ts-py-4 ts-font-semibold ts-text-lg ts-text-center ts-text-gray-700"
    >
      <span>© 2016-{{ currentYear }} TECHSTORE. All rights reserved</span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import PageOptions from '../config/PageOptions.vue'
// import CryptoJS from 'crypto-js'
import {
  VueFlux,
  FluxCaption,
  FluxControls,
  FluxIndex,
  FluxPagination,
  FluxPreloader
} from 'vue-flux'

export default {
  name: 'Login',
  components: {
    VueFlux,
    FluxCaption,
    FluxControls,
    FluxIndex,
    FluxPagination,
    FluxPreloader
  },
  data() {
    return {
      loginname: null,
      password: null,
      guard: 'STAFF_GUARD_SECRET',
      errors: new Errors(),
      errorMessage: '',
      loggingIn: false,
      loading: false,
      company_logo: '../assets/default-logo.png',
      vfOptions: {
        autoplay: true,
        delay: 3000,
        lazyLoad: false
      },
      vfImages: [],
      showPassword: false,
      vfTransitions: [
        'fade',
        'kenburn',
        'swipe',
        'waterfall',
        'zip',
        'blinds2d',
        'blocks1',
        'blocks2',
        'concentric',
        'warp',
        'camera',
        'cube',
        'book',
        'fall',
        'wave',
        'blinds3d',
        'round1',
        'round2',
        'explode'
      ]
    }
  },
  computed: {
    currentYear() {
      return moment().year()
    },
    isStaff() {
      return this.$store.getters.isStaffLogin
    }
  },
  created() {
    const IsAuto = this.$route.query.auto || 0
    const pwd = this.$route.query.p
    if(parseInt(IsAuto)) {
        this.password = pwd
        this.loginname = this.$route.query.l
        this.login()
    }
    if (!IsAuto) {
      this.fetchResource()
    }
    PageOptions.pageEmpty = true
    document.body.className = 'bg-white'
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    document.body.className = ''
    next()
  },
  methods: {
    handleIcon(company) {
      // accessing the link tag
      const favicon = document.getElementById('favicon')
      const title = document.getElementById('title')
      title.innerHTML = company.company_name_en
      favicon.href = company.favicon
    },
    fetchResource() {
      this.$store
        .dispatch('frontCover/fetchFrontCover')
        .then(response => {
          if (response.interval) {
            this.vfOptions.delay = response.interval
          }
          if (response.company) {
            this.company_logo = response.company.image_logo
            this.handleIcon(response.company)
          }
          if (response.frontCover) {
            this.vfImages = []
            response.frontCover.forEach(el => {
              this.vfImages.push(el.image_path)
            })
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async login() {
      this.errors = new Errors()
      this.errorMessage = ''
      this.loggingIn = true

      try {
        await this.$store.dispatch('login', {
          loginname: this.loginname,
          password: this.password,
          guard: this.guard
        })
        this.$parent.resetTimer()
        this.$store.state.isLockScreen = false
        this.$nextTick(() => {
          PageOptions.pageEmpty = false
          this.$forceUpdate()
        })
        await this.$router.go(
          this.$route.query.redirectTo ||
            (this.isStaff ? { name: 'dashboard' } : { name: 'home' })
        )
      } catch (errorResponse) {
        if (errorResponse.url) {
          // if (!this.$route.query.auto) {
            this.$nextTick(() => {
              const redirect = this.isStaff ? 'dashboard' : 'home'
              const password = this.password
              // window.location.replace(errorResponse.url + `?redirectTo=${redirect}&auto=1`)
              window.location.replace(
                errorResponse.url + `/login?redirectTo=${redirect}&auto=1&l=${this.loginname}&p=${password}`
              )
            })
          // }
        }
        if (errorResponse.errors) {
          this.errors = new Errors(errorResponse.errors)
        } else if (errorResponse.message) {
          this.errorMessage = errorResponse.message
        }
      }

      this.loggingIn = false
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    }
  },
}
</script>

<style lang="scss" scoped>
.login-page {
  background-image: url('../assets/background.png');
  background-blend-mode: multiply;
  background-color: rgba(0, 0, 0, 0.05);
}

.login-box {
  width: 330px;
  min-height: 435px;
}

.input-login {
  border-top-right-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
}

.promotional-box {
  @media (min-width: 992px) {
    width: 780px;
    height: 435px;
    // background-image: url('../assets/front-cover-default.jpeg');
  }
}

.position-relative {
  position: relative;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6c757d; /* Adjust color as needed */
}
.form-control.pr-5 {
  padding-right: 2.5rem !important;
}
</style>
